'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoEdit = function IoEdit(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.8 14.8l-19.6 19.6-7.1-7.1 19.6-19.6z m4.6-7.9c0.9 0.9 0.8 2.5-0.2 3.5l-3.5 3.5-7.1-7.1 3.5-3.5c1-1 2.6-1.1 3.5-0.2z m-31.9 21.5l6.6 6.6-9.1 2.5z' })
        )
    );
};

exports.default = IoEdit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/edit.js
// module id = 2013
// module chunks = 0